import { Footer as DSFooter } from '@zappyrent/hundop';
import { upperCase } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useParams, useSearchParams } from 'react-router-dom';

const vatNumber = '05477800873';
const referralContacts = {
  email: 'referral@zappyrent.com',
  phone: '+39 351 8942541',
};

const Footer = (): JSX.Element => {
  const { locale } = useParams();
  const { t } = useTranslation(['navigation', 'miscellaneous', 'product']);
  const [searchParams] = useSearchParams();

  const utmSource = searchParams.get('utm_source');
  const utmMedium = searchParams.get('utm_medium');
  const utmCampaign = searchParams.get('utm_campaign');
  const utmQueryString = `utm_source=${utmSource}&utm_medium=${utmMedium}&utm_campaign=${utmCampaign}`;

  const footerProps = {
    content: [
      {
        title: 'ZAPPYRENT',
        body: [
          {
            text: t('navigation:whoWeAre'),
            title: t('navigation:whoWeAre'),
            url: `${process.env.REACT_APP_SITE_URL}/${locale}/who/we/are`,
          },
          {
            text: t('navigation:workWithUs'),
            title: t('navigation:workWithUs'),
            url: `${process.env.REACT_APP_SITE_URL}/${locale}/careers`,
          },
          {
            text: t('navigation:pressRoom'),
            title: t('navigation:pressRoom'),
            url: `${process.env.REACT_APP_SITE_URL}/it/press`,
          },
        ],
        key: 'main',
      },
      {
        title: upperCase(t('product:tenant')),
        body: [
          {
            text: t('navigation:tenantsFAQ'),
            title: t('navigation:tenantsFAQ'),
            url: t('navigation:tenantsFAQLink'),
          },
        ],
        key: 'tenant',
      },
      {
        title: upperCase(t('product:landlord')),
        body: [
          {
            text: t('navigation:publishAListing'),
            title: t('navigation:publishAListing'),
            url: `${process.env.REACT_APP_SITE_URL}/it/pubblica-annuncio-gratis`,
          },
          {
            text: t('navigation:howToRentAHome'),
            title: t('navigation:howToRentAHome'),
            url: `${process.env.REACT_APP_SITE_URL}/it/come-affittare-casa`,
          },
          {
            text: t('navigation:landlordsFAQ'),
            title: t('navigation:landlordsFAQ'),
            url: `${process.env.REACT_APP_SITE_URL}/it/come-affittare-casa#faq`,
          },
          {
            text: t('product:protezioneZappyrent'),
            title: t('product:protezioneZappyrent'),
            url: `${process.env.REACT_APP_SITE_URL}/it/protezione-zappyrent`,
          },
          {
            text: t('navigation:rentsBlog'),
            title: t('navigation:rentsBlog'),
            url: `${process.env.REACT_APP_SITE_URL}/it/blog`,
          },
        ],
        key: 'landlord',
      },
      {
        title: 'REFERRER',
        body: [
          {
            text: t('navigation:inviteALandlord'),
            title: t('navigation:inviteALandlord'),
            url: `${process.env.REACT_APP_SITE_URL}/${locale}/refer-a-landlord/`,
          },
          {
            text: t('navigation:myReferrals'),
            title: t('navigation:myReferrals'),
            url: `${process.env.REACT_APP_REFERRAL_SITE_URL}/${locale}?${utmQueryString}`,
          },
          {
            text: t('navigation:referralsFaq'),
            title: t('navigation:referralsFaq'),
            url: `${process.env.REACT_APP_SITE_URL}/${locale}/refer-a-landlord/#faq`,
          },
          {
            text: t('navigation:termsAndConditions'),
            title: t('navigation:termsAndConditions'),
            url: t('navigation:referralProgramTermsAndConditionsLink'),
          },
        ],
        key: 'referrer',
      },
    ],
    cookiePolicyLink: `${process.env.REACT_APP_SITE_URL}/${locale}/privacy/cookie`,
    termsAndConditionsLink: `${process.env.REACT_APP_SITE_URL}/${locale}/terms/conditions`,
    privacyPolicyLink: `${process.env.REACT_APP_SITE_URL}/${locale}/privacy/policy`,
    labels: {
      emailAddress: referralContacts.email,
      contactUs: upperCase(t('navigation:contactUs')),
      phoneNumber: referralContacts.phone,
      termsAndConditions: t('navigation:termsAndConditions'),
      vat: t('miscellaneous:vat'),
      vatNumber,
    },
  };

  return <DSFooter {...footerProps} />;
};

export default Footer;
